import { apiGet, apiPatch } from './client';

export interface AppNotification {
  id: string;
  type: string;
  title: string;
  message: string;
  link?: string;
  read: boolean;
  created_at: string;
}

export function fetchNotifications(): Promise<AppNotification[]> {
  return apiGet<AppNotification[]>('/api/notifications');
}

export function markNotificationRead(id: string): Promise<void> {
  return apiPatch<void>(`/api/notifications/${id}`, {});
}

export function markAllNotificationsRead(): Promise<void> {
  return apiPatch<void>('/api/notifications', {});
}
